/**
 * Marca de campo obligatorio: un asterisco ámbar después de la etiqueta (oculto al lector de pantalla, que en su
 * lugar lee "obligatorio"). El campo en sí se marca con `required` o con `faltaSi` (ver useCamposObligatorios).
 */
export function Obligatorio() {
  return (
    <>
      <span aria-hidden="true" className="text-amber-600 ml-0.5">*</span>
      <span className="sr-only">obligatorio</span>
    </>
  );
}

/** Leyenda del formulario que explica el asterisco. */
export function LeyendaObligatorio({ className = '' }: { className?: string }) {
  return (
    <p className={`text-xs text-slate-500 ${className}`}>
      <span aria-hidden="true" className="text-amber-600">*</span> obligatorio
    </p>
  );
}
